// TransectsPropertiesForm.jsx
import React from "react"
import { Grid, Button } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @returns UI for interactive swmm modeling.
 */
export default function TransectsPropertiesForm({model, setModel, target, setFullModel}) {
  // When there is a change to an input element, modify the model.
  const updateValue = (val, varName) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ''
    if(model && model.TRANSECTS && model.TRANSECTS[target]){
      setModel(prev => ({
        ...prev,
        TRANSECTS:{
          ...prev.TRANSECTS,
          [target]: {
            ...prev.TRANSECTS[target],
            [varName]: val
          }
        }
      }))
    }
  }
  
  const saveEdits = () => {
    setFullModel(prev => ({
      ...prev, 
      TRANSECTS: {
        ...prev.TRANSECTS, 
        [target]: model.TRANSECTS[target]
      }
    }))
  }
  
  // Descriptive text and names of parameters
  const UIParams = [
    {name: 'Nleft',  uiText: 'Left Bank'},
    {name: 'Nright',  uiText: 'Right Bank'},
    {name: 'Nchanl', uiText: 'Channel'},
    {name: 'Xleft', uiText: 'Left'},
    {name: 'Xright', uiText: 'Right'},
    {name: 'Wfactor', uiText: 'Stations'},
    {name: 'Eoffset', uiText: 'Elevations'},
    {name: 'Lfactor', uiText: 'Meander'},
  ]

  return(
    <>
    {
      model.TRANSECTS &&
      model.TRANSECTS[target] &&
      <>
      <Grid container style={{fontSize: '12px'}}>
        <div style={{width: '100%'}}>
          <Button fullWidth onClick={saveEdits} >Save Edits</Button>
        </div>
        {
        UIParams.map((v, i)=>{
          return (
            <React.Fragment key={'TransectsContainer'+i}>
              {
                (i===0 &&
                <div style={{paddingTop: '15px'}}>Roughness:</div>)
                ||
                (i===3 &&
                <div style={{paddingTop: '15px'}}>Bank Stations:</div>)
                ||
                (i===5 &&
                <div style={{paddingTop: '15px'}}>Modifiers:</div>)
              }
              <Grid container >
                <Grid item xs={3} style={{fontSize: '10px'}}>
                  {
                    <label  style={{height: '22px'}}
                            className='editor-small'
                            key={'TransectsProperty_text_'+v.name.toString()}
                    >{v.uiText}</label>
                  }
                </Grid>
                <Grid item xs={9}>
                  {
                    <input  type = "text"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, v.name)}}
                      value={model.TRANSECTS[target][v.name]}
                      id={'TransectsProperty_'+v.toString()}
                      key={'TransectsProperty_'+v.toString()}
                    />
                  }
                </Grid>
              </Grid>
            </React.Fragment>
          )
        })
        }
      </Grid>
      </>
    }
    </>
  )
}